/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PixtaSearchedItem,
    PixtaSearchedItemFromJSON,
    PixtaSearchedItemFromJSONTyped,
    PixtaSearchedItemToJSON,
} from './PixtaSearchedItem';

/**
 * PIXTA画像検索APIのレスポンスデータ
 * @export
 * @interface SearchPixtaImageSuccessResponseData
 */
export interface SearchPixtaImageSuccessResponseData {
    /**
     * 検索結果件数
     * @type {number}
     * @memberof SearchPixtaImageSuccessResponseData
     */
    total: number;
    /**
     * 現在の検索結果ページ番号
     * @type {number}
     * @memberof SearchPixtaImageSuccessResponseData
     */
    page: number;
    /**
     * 1ページあたりの件数
     * @type {number}
     * @memberof SearchPixtaImageSuccessResponseData
     */
    rows: number;
    /**
     * 検索結果データ
     * @type {Array<PixtaSearchedItem>}
     * @memberof SearchPixtaImageSuccessResponseData
     */
    items: Array<PixtaSearchedItem>;
}

export function SearchPixtaImageSuccessResponseDataFromJSON(json: any): SearchPixtaImageSuccessResponseData {
    return SearchPixtaImageSuccessResponseDataFromJSONTyped(json, false);
}

export function SearchPixtaImageSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPixtaImageSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'page': json['page'],
        'rows': json['rows'],
        'items': ((json['items'] as Array<any>).map(PixtaSearchedItemFromJSON)),
    };
}

export function SearchPixtaImageSuccessResponseDataToJSON(value?: SearchPixtaImageSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'page': value.page,
        'rows': value.rows,
        'items': ((value.items as Array<any>).map(PixtaSearchedItemToJSON)),
    };
}

